import {
  PopoverHeader,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  Flex,
  ButtonGroup,
  Button,
} from '@frontend/legacy-components';

type ConfirmReplaceQuantitiesPopoverContentProps = {
  onConfirm: () => void;
  onCancel: () => void;
  numberOfLineItems: number;
  submitButtonRef: React.LegacyRef<HTMLButtonElement>;
};

export const ConfirmReplaceQuantitiesPopoverContent = ({
  onConfirm,
  onCancel,
  numberOfLineItems,
  submitButtonRef,
}: ConfirmReplaceQuantitiesPopoverContentProps) => {
  return (
    <PopoverContent>
      <PopoverHeader>
        Replace quantities on {numberOfLineItems} line items?
      </PopoverHeader>
      <PopoverBody>
        Existing quantities will be removed. <br />
        This cannot be undone.
      </PopoverBody>
      <PopoverFooter>
        <Flex justify="flex-end">
          <ButtonGroup size="sm">
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              colorScheme="destructive"
              onClick={onConfirm}
              ref={submitButtonRef}
            >
              Replace Quantities
            </Button>
          </ButtonGroup>
        </Flex>
      </PopoverFooter>
    </PopoverContent>
  );
};
